import routes from 'global/Constants/routes';

import { lazy } from 'react';

const FinanceInvoice = lazy(() => import('../../pages/dashboard/Finance/FinanceInvoice/Voucher'));
const Invoices = lazy(() => import('../../pages/dashboard/Finance/FinanceInvoice/Invoices'));
const FinanceWalletRefund = lazy(() => import('../../pages/dashboard/Finance/WalletRefund/WalletRefund'));
const CustomerFinancial = lazy(() => import('../../pages/dashboard/Finance/CustomerFinancial/CustomerFinancial'));
const CustomerCodSettlementsList = lazy(() => import('../../pages/dashboard/Finance/CustomerCodSettlements/CustomerCodSettlementsList'));

export const financeRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.customerCodSettlementsList.path,
    component: CustomerCodSettlementsList,
    isPrivate: routes.customerCodSettlementsList.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.invoices.path,
    component: Invoices,
    isPrivate: routes.invoices.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.customerFinancial.path,
    component: CustomerFinancial,
    isPrivate: routes.financeWalletRefund.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.financeWalletRefund.path,
    component: FinanceWalletRefund,
    isPrivate: routes.financeWalletRefund.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.financeInvoice.path,
    component: FinanceInvoice,
    isPrivate: routes.financeInvoice.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
